import React from 'react';
import { Segment, Button, Icon, Table, Checkbox, Header, Form, Loader, Grid, Message, Divider } from 'semantic-ui-react';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';

import ConnectStudentWithCandidate from './ConnectStudentWithCandidate';


axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

const NoDataMessage = () => <p>Nema predmeta.</p>;
export default class Status extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isConnected: false,
            loader: true,
            show: true,
            disableButton: true,

            courseEquivalence: [],
        };
        this.ShowComponentByKey = this.ShowComponentByKey.bind(this);
        this.closeForm = this.closeForm.bind(this);
        this.connectCandidateWithStudent = this.connectCandidateWithStudent.bind(this);
        this.getCourseEquivalence = this.getCourseEquivalence.bind(this);
        this.cancelCandidate = this.cancelCandidate.bind(this);
    }
    componentDidMount() {
        // this.updateIsConnected()
        this.getCourseEquivalence();
        let element = document.querySelectorAll('#myTab:nth-child(1)');

        element[0].childNodes[1].classList.remove('segment');
    }

    connectCandidateWithStudent(studentId, studyProgramSemesterId) {
        let candidateId = localStorage.getItem('candidateId');
        this.setState({
            hide: false
        });
        let obj = {
            id: studyProgramSemesterId
        };
        axios.post(`/equivalence/${candidateId}/connect/${studentId}`, { ...obj }).then(response => {
            localStorage.setItem('candidateEquivalenceStatus', 'MERGED');// if it changes on backend, change here too
            this.setState({ candidateEquivalenceStatus: localStorage.getItem('candidateEquivalenceStatus') });
            this.props.getCandidate();
            this.closeForm();
        }).catch(() => {
            toast('Povezivanje nije uspjelo!');
        });
    }


    ShowComponentByKey(key) {
        if (key === 'add') {
            this.setState({
                showAddCourse: true,
                showConnectStudent: false
            });
        } else if (key === 'connect') {
            this.setState({
                showAddCourse: false,
                showConnectStudent: true,
            });
        }
    }

    closeForm() {
        this.setState({
            showAddCourse: false,
            showConnectStudent: false,
            show: false


        });
    }
    getCourseEquivalence() {
        let candidateId = localStorage.getItem('candidateId');
        axios.get(`/equivalence/${candidateId}/courses`).then(res => {
            let courseEquivalence = res.data.map(el => ({

                sourceCourseName: el.sourceCourseName,
                targetCourseName: el.targetCourseName,
                studyProgramSemester: el.studyProgramSemester,
                ects: el.ects,
                mark: el.mark,
                status: el.status,
            }));
            this.setState({
                courseEquivalence, loader: false
            });
        }).catch(err => {
            this.setState({
                loader: false
            });
            toast('Trenutno nije moguće dobaviti izvještaj!');
        });
        return this.state.courseEquivalence;
    }
    cancelCandidate() {
        this.setState({ disableButton: true });
        let candidateId = localStorage.getItem('candidateId');
        axios.post(`/equivalence/${candidateId}/refused-to-enroll`, {}).then(res => {
            localStorage.setItem('candidateEquivalenceStatus', 'REFUSED_TO_ENROLL');// if it changes on backend, change here too
            this.setState({ candidateEquivalenceStatus: localStorage.getItem('candidateEquivalenceStatus') });
        });
    }


    render() {
        return (

            <div>

                {this.state.showConnectStudent && <Divider horizontal>
                    <Header as="h4">
                        Povezivanje kandidata sa studentom
                    </Header>
                </Divider>
                }
                {this.state.showConnectStudent && <ConnectStudentWithCandidate connectCandidateWithStudent={this.connectCandidateWithStudent} closeForm={this.closeForm} />
                }

                { !this.state.showConnectStudent && localStorage.getItem('candidateEquivalenceStatus') === 'IN_PROGRESS' && <Grid columns={2}>


                    <Grid.Column>
                        <Button
                            basic
                            icon={localStorage.getItem('candidateEquivalenceStatus') === 'MERGED' ? 'check' : 'warning'}
                            content={localStorage.getItem('candidateEquivalenceStatus') === 'MERGED' ? 'Kandidat i student su povezani' : 'Poveži kandidata sa studentom'}
                            fluid
                            color="blue"
                            floated="right"
                            onClick={() => {
                                this.ShowComponentByKey('connect');
                            }}
                        />
                    </Grid.Column>
                    <Grid.Column>
                        <Button
                            basic
                            fluid
                            icon="cancel"
                            content="Odustao"
                            color={localStorage.getItem('candidateEquivalenceStatus') === 'REFUSED_TO_ENROLL' ? 'green' : 'red'}
                            floated="right"
                            onClick={() => {
                                this.cancelCandidate();
                            }}
                        />
                    </Grid.Column>


                </Grid>
                }
                {localStorage.getItem('candidateEquivalenceStatus') === 'MERGED' && <Message success>  <Icon name="checkmark" /> Nakon izvršene ekvivalencije kandidat je upisan i povezan sa studentom.</Message>}

                {localStorage.getItem('candidateEquivalenceStatus') === 'REFUSED_TO_ENROLL' && <Message error> <Icon name="times" /> Nakon izvršene ekvivalencije kandidat je odustao od upisa.</Message>}


                <ToastContainer hideProgressBar />

            </div>

        );
    }
}




// WEBPACK FOOTER //
// ./src/views/StudentService/ExamEquivalence/Candidates/CandidatesDetails/Status/Status.js